import { AzureDataBricksLinkedService } from './../linkedservice/azure-data-bricks.linkedservice';

import { Metamodel } from '../base/model';
import { IModel, IViolation, ModelConstants, ParameterValue } from 'shell-models-lib';
import { Activity } from './activity';
import { Collection, IAttribute } from 'app/model/base/annotation';
import { format } from 'app/shared/utils/string.util';
import { ParameterConfigString } from 'app/model/pipeline/parameter-config-string';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config-string.util';
@Metamodel.model({
    name: ModelConstants.jobActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Job_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Job_DisplayText)
    ],
    referable: true
})
export class JobActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly JOBID: IAttribute;
    public static readonly LIBRARIES: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.JobActivity_ModelName,
        constraint: {
            required: true
        },
        templatable: true,
        association: 'JOBID'
    })
    public jobId?: string;

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataBricks_DisplayText),
        constraint: {
            required: true
        },
        reference: true,
        type: AzureDataBricksLinkedService.MODEL
    })
    public linkedService?: AzureDataBricksLinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters: ParameterValue[] = [];

    @Metamodel.attribute({
        display: stringResources.Databricks_JobActivity_JobParameterName,
        constraint: {
            validator: JobActivity.validateParameters
        }
    })
    public jobParameters?: ParameterConfigString[];

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    private static async validateParameters(
        dbActivity: JobActivity,
        parameters?: ParameterConfigString[]
    ): Promise<IViolation[] | undefined> {
        return createParameterConfigurationValidator()(dbActivity, parameters as ParameterConfigString[]);
    }
}


